import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Fab from '@material-ui/core/Fab';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Paper';

import ContentAddIcon from '@material-ui/icons/Add';
import ClearIcon from '@material-ui/icons/Clear';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';

const mTypeAndInstance = {
  'all': 'all',
  'alL': 'all',
  'aLl': 'all',
  'aLL': 'all',
  'All': 'all',
  'AlL': 'all',
  'ALl': 'all',
  'ALL': 'all'
};

const isGlobal = (type, instance) => {
  return ('all' === mTypeAndInstance[type] || 'all' === mTypeAndInstance[instance]);
}; 

const PreferenceDialog = (props) => {
  const [type, setType] = useState(props.type || '');
  const [instance, setInstance] = useState(props.instance || '');
  const [inputs, setInputs] = useState(props.attributes && props.attributes.length ? props.attributes : [{ name: '', value: '', description: '', isNew: props.dlgType === 'edit' }]);
  const [remType, setRemType] = useState('');

  const isOverride = (override) => {
    return (typeof override === 'undefined') ? isGlobal(type, instance) : override;
  };

  const updateName = (e, index) => {
    const updateInputs = inputs.map((input, idx) => {
      if (index === idx) {
        return { ...input, name: e.target.value };
      }
      return input;
    });
    setInputs(updateInputs);
  };

  const updateValue = (e, index) => {
    const updateInputs = inputs.map((input, idx) => {
      if (index === idx) {
        return { ...input, value: e.target.value };
      }
      return input;
    });
    setInputs(updateInputs);
  };

  const updateDescription = (e, index) => {
    const updateInputs = inputs.map((input, idx) => {
      if (index === idx) {
        return { ...input, description: e.target.value };
      }
      return input;
    });
    setInputs(updateInputs);
  };

  const updateOverride = (e, index) => {
    const updateInputs = inputs.map((input, idx) => {
      if (index === idx) {
        return { ...input, override: e.target.checked };
      }
      return input;
    });
    setInputs(updateInputs);  
  };

  const addAttributes = () => {
    const attr = { name: '', value: '', description: '' };
    if (props.dlgType === 'edit') {
      attr.isNew = true;
    }
    setInputs([ ...inputs, { ...attr }]);
  };

  const removeInput = (index) => {
    const removed = inputs.filter((_, idx) => {
      return idx !== index;
    });
    setInputs(removed);
  };

  const actionByType = () => {
    if (props.dlgType === 'create') {
      const mType = mTypeAndInstance[type] || type;
      const mIns = mTypeAndInstance[instance] || instance;
      const attributes = inputs.map(({ name = '', value = '', description = '', override }) => {
        return { name, value, description, override: isOverride(override) };
      });
      const disabled = !type || !instance || !(inputs.length && inputs[inputs.length - 1].name);
      return (
        <Button variant='contained' color='primary' disabled={disabled} autoFocus 
          onClick={() => props.handleOk({ type: mType, instance: mIns, attributes })}
        >Create Preference
        </Button>
      );
    } else if (props.dlgType === 'edit') {
      const attributes = inputs.map(({ name = '', value = '', description = '', override, isNew }) => {
        return { name, value, description, override: isOverride(override), isNew };
      });     
      return (
        <Button variant='contained' color='primary' autoFocus
          onClick={() => props.handleOk(attributes)}
        >Save changes</Button>
      );
    } else if (props.dlgType === 'remove') {
      return <Button variant='contained' color='primary' disabled={props.type !== remType} autoFocus
        onClick={() => props.handleOk()}>Delete Preference</Button>;
    }
  };
  const titleByType = () => {
    if (props.dlgType === 'create') {
      return 'Create Preference';
    } else if (props.dlgType === 'edit') {
      return 'Edit Preference';
    } else if (props.dlgType === 'remove') {
      return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <ReportProblemIcon style={{ marginRight: 8 }}/>
          <Typography>Delete Preference</Typography>
        </div>
      );
    }
  };
  const contentByType = () => {
    if (props.dlgType === 'create' || props.dlgType === 'edit') {
      return (
        <>
          <Grid container spacing={1}>
            <Grid item>
              <TextField label='Type' value={type} 
                onChange={e => setType(e.target.value)}
                required variant='filled'
                disabled={props.dlgType === 'edit'} 
              />
            </Grid>
            <Grid item>
              <TextField label='Instance' value={instance}
                onChange={e => setInstance(e.target.value)}
                required variant='filled'
                disabled={props.dlgType === 'edit'}
              />
            </Grid>
          </Grid>
          <Divider style={{ margin: '8px 0px'}} />
          <Typography>Attributes</Typography>
          <Paper style={{ padding: 8 }}>
            {
              inputs.map(({ name, value, description, override, isNew }, idx) => {
                return (
                  <Grid container key={idx} spacing={1}>
                    <Grid item>
                      <TextField label='Name' value={name} required 
                        disabled={props.dlgType === 'edit' && !isNew}
                        onChange={e => updateName(e, idx)}
                        variant='filled'
                      />
                    </Grid>
                    <Grid item>
                      <TextField label='Value' value={value} required 
                        onChange={e => updateValue(e, idx)}
                        variant='filled'
                      />
                    </Grid>
                    <Grid item>
                      <TextField label='Description' value={description} required 
                        onChange={e => updateDescription(e, idx)}
                        variant='filled'
                      />
                    </Grid>
                    <Grid item>
                      <FormControlLabel disabled={!isGlobal(type, instance)}
                        control={<Checkbox 
                          checked={isOverride(override)} 
                          onChange={ e => updateOverride(e, idx)}
                        />}
                        label='Override'
                      /> 
                    </Grid>
                    <Grid item>
                      <IconButton onClick={() => removeInput(idx)}>
                        <ClearIcon fontSize="small" />
                      </IconButton>                      
                    </Grid>
                  </Grid>
                );
              })
            }
          </Paper>
          <Fab
            disabled={!((inputs.length === 0) || (inputs.length > 0 && inputs[inputs.length - 1].name))}
            style={{ marginTop: '10px' }}
            color="secondary"
            size="small"
            onClick={() => addAttributes()}
          >
            <ContentAddIcon />
          </Fab>                   
        </>
      );
    } else if (props.dlgType === 'remove') {
      return (
        <>
          <Typography>{`Are you sure to delete preference: type='${props.type}', instance='${props.instance}' ?`}</Typography>
          <Typography color='primary'>All Data related to the preference will be permanently deleted. {`Confirm by typing the type '${props.type}' in the box below`}</Typography>
          <TextField label='Type' value={remType}
            onChange={e => setRemType(e.target.value)}
            fullWidth required 
          />
        </>
      );
    }
  };
  return (
    <Dialog
      open={props.open}
      maxWidth='md'
    >
      <DialogTitle>{titleByType()}</DialogTitle>
      <DialogContent>
        {contentByType()}
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={props.handleCancel}>Cancel</Button>
        {actionByType()}
      </DialogActions>
    </Dialog>
  );
};

PreferenceDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  dlgType: PropTypes.string,
  type: PropTypes.string,
  instance: PropTypes.string,
  attributes: PropTypes.array,
  handleOk: PropTypes.func,
  handleCancel: PropTypes.func,
  name: PropTypes.string,
  status: PropTypes.string
};

export default PreferenceDialog;
